<!-- <p>bulk-invite works!</p> -->

<mat-grid-list
  [cols]="screenInfo == ScreenType.Mobile ? '1' : '2'"
  [rowHeight]="screenInfo == ScreenType.Mobile ? '125px' : '150px'"
  gutterSize="10px"
>
  <mat-grid-tile [rowspan]="screenInfo == ScreenType.Mobile ? '4' : '5'"
    ><div class="calendar-container">
      <div class="calendar-header"><h6>Select Date</h6></div>
      <app-calendar-date
        (selectedDate)="getSelectedDate($event)"
      ></app-calendar-date>
      <div *ngIf="false" class="calendar-footer-button">
        <button (click)="sendBulkInvite()" mat-raised-button>
          Send bulk invite
        </button>
      </div>
    </div></mat-grid-tile
  >
  <mat-grid-tile
    *ngIf="isSendBulkInvite || true"
    [rowspan]="
      screenInfo == ScreenType.Mobile && !(isManualTypeValues || isFileSelected)
        ? 5
        : screenInfo == ScreenType.Mobile &&
          (isManualTypeValues || isFileSelected)
        ? 10
        : screenInfo != ScreenType.Mobile &&
          (isManualTypeValues || isFileSelected)
        ? 5
        : 5
    "
  >
    <div
      [ngClass]="{
        'calendar-details-form-container':
          screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
        'calendar-details-form-container-mobile':
          screenInfo == ScreenType.Mobile
      }"
    >
      <div
        [ngClass]="{
          'calendar-header':
            screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
          'calendar-header-mobile': screenInfo == ScreenType.Mobile
        }"
      >
        <h6>Invite details form for {{ dateSelected | date }}</h6>
      </div>
      <div class="calendar-details-form">
        <form [formGroup]="bulkInviteForm">
          <mat-grid-list
            cols="2"
            rowHeight="80px"
            [gutterSize]="screenInfo == ScreenType.Mobile ? '5px' : '10px'"
          >
            <mat-grid-tile colspan="2"
              ><div class="internalMatGrid">
                <mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Title for the event</mat-label>
                  <input matInput formControlName="eventTitle" />
                </mat-form-field></div
            ></mat-grid-tile>
            <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
              ><div class="internalMatGrid">
                <mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Reason for invite</mat-label>
                  <mat-select formControlName="inviteReason">
                    <mat-option value="Party">Party</mat-option>
                    <mat-option value="Official">Official</mat-option>
                    <mat-option value="Social">Social</mat-option>
                    <mat-option value="Meeting">Meeting</mat-option>
                    <mat-option value="Gathering">Gathering</mat-option>
                    <mat-option value="Other">Other</mat-option>
                  </mat-select>
                </mat-form-field>
              </div></mat-grid-tile
            >
            <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
              ><div class="internalMatGrid">
                <mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Link it to an existing Event</mat-label>
                  <mat-select formControlName="linkEvent">
                    <mat-option>-- None --</mat-option>
                    <mat-option
                      *ngFor="let event of userEvents"
                      [value]="event.eventId"
                      >{{ event.eventTitle }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div></mat-grid-tile
            >
            <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
              ><div class="mat-tile-button">
                <button
                  [disabled]="bulkInviteForm.invalid"
                  (click)="typeManualValues()"
                  mat-raised-button
                  type="button"
                >
                  Manually Add Guests
                </button>
              </div>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
              ><div class="mat-tile-button">
                <button
                  type="button"
                  [disabled]="bulkInviteForm.invalid"
                  (click)="selectFile()"
                  mat-raised-button
                >
                  Upload Guest List <mat-icon matSuffix>attach_file</mat-icon>
                </button>
                <input
                  type="file"
                  #fileInput
                  style="display: none"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  (change)="onFileSelected($event)"
                /></div
            ></mat-grid-tile>

            <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 2 : 2"
              ><div class="mat-tile-button-attachment">
                <button
                  type="button"
                  [disabled]="bulkInviteForm.invalid"
                  (click)="fileInput1.click()"
                  mat-raised-button
                >
                  Add Attachment
                </button>
                <div class="selected-attachment-container">
                  <p *ngIf="selectedAttachment">
                    Attachment: <b>{{ selectedAttachment.name }}</b>
                  </p>
                </div>
                <input
                  type="file"
                  #fileInput1
                  style="display: none"
                  accept=".pdf, .jpeg, .png"
                  (change)="onAttachmentSelected($event)"
                /></div
            ></mat-grid-tile>
            <mat-grid-tile
              *ngIf="false"
              [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
            >
              <div class="selected-attachment-container">
                <p *ngIf="selectedAttachment">
                  Attachment: <b>{{ selectedAttachment.name }}</b>
                </p>
              </div>
            </mat-grid-tile>

            <mat-grid-tile
              colspan="2"
              [rowspan]="screenInfo == ScreenType.Mobile ? 5 : 2"
              *ngIf="isManualTypeValues && !isFileSelected"
            >
              <div
                [ngClass]="{
                  'manual-enter-fields-wrapper':
                    screenInfo == ScreenType.Desktop ||
                    screenInfo == ScreenType.Tablet,
                  'manual-enter-fields-wrapper-mobile':
                    screenInfo == ScreenType.Mobile
                }"
              >
                <form
                  [formGroup]="manualTypeForm"
                  class="manual-enter-csv-fields-container"
                >
                  <div class="top-fields">
                    <mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>First Name</mat-label>
                      <input matInput formControlName="firstName" />
                    </mat-form-field>
                    <mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Last Name</mat-label>
                      <input matInput formControlName="lastName" />
                    </mat-form-field>
                  </div>
                  <div class="bottom-fields">
                    <!-- <mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Phone Number</mat-label>
                      <input
                        (keypress)="inputValidator($event)"
                        matInput
                        formControlName="phone"
                        maxlength="10"
                      />
                    </mat-form-field> -->
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                    >
                      <ngx-mat-intl-tel-input
                        #phoneInput
                        [enablePlaceholder]="true"
                        [required]="true"
                        [preferredCountries]="['in']"
                        [enableSearch]="true"
                        name="phone"
                        formControlName="phoneNumber"
                        [inputPlaceholder]="'Phone Number *'"
                        [label]="'Phone Number'"
                        [maxlength]="15"
                      ></ngx-mat-intl-tel-input>
                      <mat-error
                        *ngIf="manualTypeForm.controls['phoneNumber']?.errors?.['validatePhoneNumber']
                        &&
                        false"
                        ><i>Enter valid number</i>
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="email" />
                    </mat-form-field>
                  </div>
                </form>

                <div class="manutal-enter-action">
                  <div class="button-wrapper">
                    <button
                      (click)="addNewCsvValue()"
                      [disabled]="manualTypeForm.invalid"
                      mat-fab
                    >
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile
              colspan="2"
              [rowspan]="screenInfo == ScreenType.Mobile ? 3 : 2"
              *ngIf="
                isManualTypeValues &&
                typedCsvValues?.length > 0 &&
                !isFileSelected
              "
            >
              <div class="manual-type-table-section">
                <div
                  class="csv-table-container"
                  *ngIf="screenInfo != ScreenType.Mobile"
                >
                  <table mat-table [dataSource]="dataSource">
                    <ng-container matColumnDef="index">
                      <th mat-header-cell *matHeaderCellDef>No.</th>
                      <td mat-cell *matCellDef="let element; let i = index">
                        {{ i + 1 }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="firstname">
                      <th mat-header-cell *matHeaderCellDef>First Name</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.firstName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="lastname">
                      <th mat-header-cell *matHeaderCellDef>Last Name</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.lastName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                      <th mat-header-cell *matHeaderCellDef>Email</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.email }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="phone">
                      <th mat-header-cell *matHeaderCellDef>Phone</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.phone }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="detail">
                      <th
                        style="text-align: center"
                        mat-header-cell
                        *matHeaderCellDef
                      >
                        Action
                      </th>
                      <td
                        style="text-align: center"
                        mat-cell
                        *matCellDef="let element"
                      >
                        <button
                          (click)="removeCsvValue(element)"
                          mat-raised-button
                        >
                          <mat-icon>remove</mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: displayedColumns"
                    ></tr>
                  </table>
                </div>
                <div *ngIf="screenInfo == ScreenType.Mobile">
                  <app-table-card-display
                    [tableData]="dataSource.data"
                    (showDetails)="removeCsvValue($event)"
                  ></app-table-card-display>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="isFileSelectedError">
              <div class="error-banner">
                {{ isFileSelectedErrorMessage }}
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="isFileSelected">
              <div
                [ngClass]="{
                  'bulk-invite-csv-details':
                    screenInfo == ScreenType.Desktop ||
                    screenInfo == ScreenType.Tablet,
                  'bulk-invite-csv-details-mobile':
                    screenInfo == ScreenType.Mobile
                }"
              >
                <div>
                  Selected File:
                  <i
                    ><b>{{ selectedFile?.name }}</b>
                  </i>
                </div>
                <div>
                  Total Guests Found:
                  <i>
                    <b>{{ formatedCsvContent?.length }}</b>
                  </i>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile
              *ngIf="isFileSelected && iscsvContentFormated"
              colspan="2"
              rowspan="5"
            >
              <div class="bulk-invite-csv-container">
                <app-csv-table
                  [csvData]="formatedCsvContent"
                  (onSendGuestData)="sendBulkInvites($event)"
                ></app-csv-table>
              </div>
            </mat-grid-tile>
            <mat-grid-tile
              colspan="2"
              *ngIf="isManualTypeValues && typedCsvValues?.length > 0"
            >
              <div class="mat-tile-button">
                <button
                  (click)="sendBulkTypesCsvInvites($event)"
                  mat-raised-button
                  type="button"
                >
                  Send Invitations
                </button>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </form>
      </div>
    </div>
  </mat-grid-tile>
</mat-grid-list>
<br />
